import request from "@utils/request";

/**
 * 文章收藏列表接口
 * @param {Object} data
 */
export function getCollect(data) {
  return request.get("/article/collect/user", data, {}, { login: false });
}
/**
 * 用户发布的文章列表接口
 * @param {Object} data
 */
export function getRelease(data) {
  return request.get("/user/release/article", data, {}, { login: false });
}
/**
 * 团队获客统计接口
 * @param {Object} data
 */
export function getTeamGuest(data) {
  return request.get("/team/guest", data, {}, { login: false });
}
/**
 * 热文分享统计接口
 * @param {Object} data
 */
export function getHotShare(data) {
  return request.get("/hot/share", data, {}, { login: false });
}
/**
 * 会员等级列表
 * @param {Object} data
 */
export function getLevelGrade() {
  return request.get("/user/level/grade", {}, { login: false });
}
/**
 * 会员购买
 * @param {Object} data
 */
export function postLevelPay(data) {
  return request.post("/user/level/pay", data, {}, { login: false });
}

/**
 * 打卡
 * @param {Object} data
 */
export function getClock() {
  return request.get("/clock/writing", {}, { login: false });
}
/**
 *  发布文章
 * @param {Object} data
 */
export function postArtGet(data) {
  return request.post("/artGet", data, {}, { login: false });
}
/**
 *  发布视频
 * @param {Object} data
 */
export function postVideo(data) {
  return request.post("/user/sub/video", data, {}, { login: false });
}
/**
 *  视频收藏列表接口
 * @param {Object} data
 */
export function getVideoCollect(data) {
  return request.get("/video/collect/user", data, {}, { login: false });
}
/**
 *  客户线索列表详情接口
 * @param {Object} data
 */
export function getCustomerDetails(data) {
  return request.get("/customer/details", data, {}, { login: false });
}
/**
 *  我的需求接口
 * @param {Object} data
 */
export function getDemandList(data) {
  return request.get("/demand/list", data, {}, { login: false });
}
/**
 *  人脉广场首页列表接口
 * @param {Object} data
 */
export function getContacts(data) {
  return request.get("/get/contacts/square", data, {}, { login: false });
}
/**
 *  我的需求添加及更新接口
 * @param {Object} data
 */
export function postAddDemand(data) {
  return request.post("/add/demand", data, {}, { login: false });
}
/**
 *  我发布的视频列表接口
 * @param {Object} data
 */
export function getReleaseVideo(data) {
  return request.get("/user/release/video", data, {}, { login: false });
}
/**
 *  用户信息录入接口
 * @param {Object} data
 */
export function postInformation(data) {
  return request.post("/entering/user/information", data, {}, { login: false });
}
/**
 *  获取面诊二维码接口
 * @param {Object} data
 */
export function getFaceCode(data) {
  return request.post("/face/diagnose/code", data, {}, { login: false });
}
/**
 *  录入信息详情接口
 * @param {Object} data
 */
export function getInforMation(data) {
  return request.get("/get/information/list", data, {}, { login: false });
}
/**
 *  录入信息详情接口
 * @param {Object} data
 */
export function getNewsList(data) {
  return request.get("/get/news/list", data, {}, { login: false });
}
/**
 *  获取短信key接口
 * @param {Object} data
 */
export function getVerifyCode(data) {
  return request.get("/verify_code", data, {}, { login: false });
}
/**
 *  验证码发送接口
 * @param {Object} data
 */
export function postVerifyCode(data) {
  return request.post("/register/verify", data, {}, { login: false });
}
